'use strict';
module.exports = [
    '$compile',
    function ($compile) {

        return {
            controller: ['$element', '$scope', yTextCtrl],
            controllerAs: 'ctrl',
            scope: {
                yModel: '=yText',
            },
            restrict: 'A',
            compile: function (element) {
                if (element.attr('y-text-needs-model')) {
                    element.removeAttr('y-text'); // necessary to avoid infinite compile loop
                    element.attr('ng-model', 'model');
                    let fn = $compile(element);
                    return function (scope) {
                        fn(scope);
                    };
                }
            },
        };
    }];

class yTextCtrl {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
        this.hasModel = $element.attr('y-text-needs-model');

        this.events = 'keypress blur change paste cut';

        this.yObserverHandler = this.yObserver.bind(this);
        this.onInputBlurHandler = _.debounce(this.onInputBlur.bind(this), 500, {
            maxWait: 2000,
        });

        // if (this.hasModel) {
        $scope.yModel.observe(this.yObserverHandler);
        // }

        $scope.$on('$destroy', this.destroy.bind(this));

        if (this.hasModel) {
            this.updateNgModel();
        }

        this.bindTextarea();
    }


    updateNgModel() {
        this.$scope.model = this.$scope.yModel.toString();
    }


    yObserver() {
        this.updateNgModel();

        this.$element.val(this.$scope.model);
    }


    onInputBlur() {
        const {$scope, $element} = this;

        const value = $element.val();
        $scope.yModel.delete(0, $scope.yModel.length);
        $scope.yModel.insert(0, value);
    }


    bindTextarea() {
        const {$scope, $element} = this;
        // $scope.yModel.bindTextarea($element[0]);

        $element.val($scope.yModel.toString());
        $element.on(this.events, this.onInputBlurHandler);
    }


    unbindTextarea() {
        const {$scope, $element} = this;
        // $scope.yModel.unbindTextarea($element[0]);

        $element.off(this.events, this.onInputBlurHandler);
    }


    destroy() {
        // if (this.hasModel) {
        this.$scope.yModel.unobserve(this.yObserverHandler);
        // }

        this.unbindTextarea();
    }
}
